module.exports = __webpack_public_path__ + "static/media/master.42202e82.svg";